import Vue from 'vue';
import HcxfPublicationFacets from '@/components/hcxf/hcxf-publication-facets.vue';
import HcxfPublicationSearchResults from '@/components/hcxf/hcxf-publication-search-results.vue';
import HcxfPublicationStatus from '@/components/hcxf/hcxf-publication-status.vue';
import HcxfPublicationHub from '@/components/hcxf/hcxf-publication-hub.vue';
import HcxfPublicationDetails from '@/components/hcxf/hcxf-publication-details.vue';

import HcxfPractitionerMap from '@/components/hcxf/hcxf-practitioner-map.vue';
import HcxfPractitionerResults from '@/components/hcxf/hcxf-practitioner-results.vue';
import HcxfPractitionerHub from '@/components/hcxf/hcxf-practitioner-hub.vue';
import HcxfPublicationDetailsFacets from '@/components/hcxf/hcxf-publication-details-facets.vue';

import HcxfResearchFacets from '@/components/hcxf/hcxf-research-facets.vue';
import HcxfResearchHub from '@/components/hcxf/hcxf-research-hub.vue';
import HcxfResearchSearchResults from '@/components/hcxf/hcxf-research-search-results.vue';
import HcxfResearchStatus from '@/components/hcxf/hcxf-research-status.vue';
import HcxfResearchHubDetails from './components/hcxf/hcxf-research-hub-details.vue';
import HcxfNews from './components/hcxf/hcxf-news.vue';
import HcxfNewsStatus from './components/hcxf/hcxf-news-status.vue';
import HcxfNewsResults from './components/hcxf/hcxf-news-results.vue';

Vue.component('hcxf-publication-facets', HcxfPublicationFacets);
Vue.component('hcxf-publication-search-results', HcxfPublicationSearchResults);
Vue.component('hcxf-publication-status', HcxfPublicationStatus);
Vue.component('hcxf-publication-hub', HcxfPublicationHub);
Vue.component('hcxf-publication-details', HcxfPublicationDetails);
Vue.component('hcxf-publication-details-facets', HcxfPublicationDetailsFacets);

Vue.component('hcxf-practitioner-map', HcxfPractitionerMap);
Vue.component('hcxf-practitioner-results', HcxfPractitionerResults);
Vue.component('hcxf-practitioner-hub', HcxfPractitionerHub);

Vue.component('hcxf-research-facets', HcxfResearchFacets);
Vue.component('hcxf-research-hub', HcxfResearchHub);
Vue.component('hcxf-research-search-results', HcxfResearchSearchResults);
Vue.component('hcxf-research-status', HcxfResearchStatus);
Vue.component('hcxf-research-hub-details', HcxfResearchHubDetails);

Vue.component('hcxf-news', HcxfNews);
Vue.component('hcxf-news-status', HcxfNewsStatus);
Vue.component('hcxf-news-results', HcxfNewsResults);



// WEBPACK FOOTER //
// ./src/app/hcxf.js